import { getRankingData } from '@/api/ranking'
const state = {
  rankingdata: []
}

const mutations = {
  SET_RANKING: (state, ranking) => {
    state.rankingdata = ranking
  }
}

const actions = {
  getRankingData({ commit }, query) {
    return new Promise((resolve, reject) => {
      getRankingData(query).then((response) => {
        commit('SET_RANKING', response.data)
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        commit('SET_RANKING', [])
        reject()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
